// extracted by mini-css-extract-plugin
export default {"body":"Body_body__yIXyB","buttons":"Body_buttons__atw54","btn":"Body_btn__5NSiO","active":"Body_active__siEPJ"};